import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Inject, ViewChild } from '@angular/core';
// import { HttpClient, HttpParams } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';

// Modelos
import { Estancia} from '../../../models/estancia';

import { ApiResult } from '../../../services/base.service';

// Servicios
import { EstanciasService } from '../../../services/estancias.service';
import { VisitasService } from '../../../services/visitas.service';
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'app-estancias',
  templateUrl: './estancias.component.html',
  styleUrls: ['./estancias.component.scss']
})
export class EstanciasComponent implements OnInit {

  public static IsRead = true;

  // Cabecera de las columnas de la tabla
  public displayedColumns: string[] = ['idEstancia', 'tipoEstancia'];
  // Tabla de Material
  public estancias: MatTableDataSource<Estancia>;

  // Campos de filtrado
  defaultPageIndex = 0;
  defaultPageSize = 10;
  public defaultSortColumn = 'IdEstancia';
  public defaultSortOrder = 'asc';
  pageEvent: PageEvent;

  defaultFilterColumn = 'IdEstancia';
  filterQuery: string = null;
  tiposEstancias: Map<string, string>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Input() idTasacion: number;
  @Input() version: number;
  @Input() mode: string;
  @Output() idRoom = new EventEmitter<number>();

  // Los eleemntos declarados por el constructor de esta forma estan declarados en toda la clase
  constructor(private estanciasService: EstanciasService, private router: Router) { }

  ngOnInit() {
    console.log('estancias editar load data begin');
    this.loadData();
    console.log('estancias editar load data ');
  }

  save() {

  }

  loadData(query: string = null) {
    this.estanciasService.getTipoEstancia().subscribe((res: Map<string, string>) => this.tiposEstancias = res);
    this.pageEvent = new PageEvent();
    this.pageEvent.pageIndex = this.defaultPageIndex;
    this.pageEvent.pageSize = this.defaultPageSize;
    if (query) {
      this.filterQuery = query;
    }
    this.getData(this.pageEvent);

  }

  getData(event: PageEvent) : PageEvent{
    const sortColumn = (this.sort)
      ? this.sort.active
      : this.defaultSortColumn;

      const sortOrder = (this.sort)
      ? this.sort.direction
      : this.defaultSortOrder;

      const filterColumn = (this.filterQuery)
      ? this.defaultFilterColumn
      : null;

      const filterQuery = (this.filterQuery)
      ? this.filterQuery
      : null;

    this.estanciasService.getData(
        this.idTasacion,
        this.version,
        event.pageIndex,
        event.pageSize,
        sortColumn,
        sortOrder,
        filterColumn,
        filterQuery
      )
      .subscribe( result => {
        this.paginator.length = result.totalCount;
        this.paginator.pageIndex = result.pageIndex;
        this.paginator.pageSize = result.pageSize;
        this.estancias = new MatTableDataSource<Estancia>(result.data);

      }, error => console.error(error));
      return event;
  }

  clickRow(idTasacion: number, version: number, idEstancia: number) {
    if(this.mode == 'not-edit'){
      this.idRoom.emit(idEstancia);
    } else {
      console.log(`/visita/${idTasacion}/${version}/step6/${idEstancia}`);
      this.router.navigate([`/visita/${idTasacion}/${version}/step6/${idEstancia}`]);
    }
  }

  async nuevaEstancia() {
    console.log(`Creando estancia para -> ${this.idTasacion}/${this.version}` );
    let nuevaEstancia = await this.estanciasService.newEstancia(this.idTasacion, this.version).toPromise();    
    this.loadData();
    //this.router.navigate([`/visita/${this.idTasacion}/${this.version}/step6`]);
  }
}

